import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import OverviewTabContent from './OverviewTabContent.component';
import AttendanceTabContent from './AttendanceTabContent.component';
import BookingTabContent from './BookingTabContent.component';
import LoogbookTabContent from './LoogbookTabContent.component';
import HandoverTabContent from './HandoverTabContent.component';

export const CardStyle = styled(Paper)(({ color, theme }) => ({
  marginBottom: theme.spacing(2),
  padding: theme.spacing(2),
  backgroundColor: color,
  borderRadius: theme.shape.borderRadius,
  transition: 'transform 0.2s, box-shadow 0.2s',
  boxShadow: 'none',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
  },
}));

const TabContent = ({ activeTab, yacht, yachtID, filters }) => {
  const contactOnBoard =
    yacht?.id_yacht_members?.data?.filter(
      (user) => user?.attributes?.is_delivery_manager_on_board === true
    )?.[0] || '-';

  switch (activeTab) {
    case 0:
      return (
        <OverviewTabContent operations={yacht?.id_operation_lists?.data} />
      );

    case 1:
      return <AttendanceTabContent attendances={yacht?.id_attendance?.data} />;

    case 2:
      return <BookingTabContent bookings={yacht?.id_booking?.data} />;

    case 3:
      return (
        <LoogbookTabContent
          logbooks={yacht?.id_logbooks?.data}
          contactOnBoard={contactOnBoard}
        />
      );

    case 4:
      return <HandoverTabContent yachtID={yachtID} filters={filters} />;

    default:
      return null;
  }
};

export default TabContent;